<!--suppress ALL -->

<template>
  <listTemplate :class="'height__100vh'">
    <template #header>
      <headerTemplate>
        <template #filterByStatus>
          <div class="leftSection">
            <div class="header-title wrapper-content__main font-weight__bold">
              Đưa văn bản đi về Chờ ban hành
            </div>
          </div>
        </template>
      </headerTemplate>
    </template>

    <template #view>
      <div class="view">
        <listTemplate :classCustom="'list-docs wrapper-content__main'">
          <template #subHeader>
            <subHeader>
              <template #content>
                <div >
                  <el-button
                    size="medium"
                    type="success"
                    class="createNew"
                    @click="isOpenDialogCreate = true"
                  >
                    <div class="flex-row flex__center">
                      <i class="fas fa-file-plus"></i>
                      <span>&nbsp;THAY ĐỔI</span>
                    </div>
                  </el-button>

                </div>
                <searchTemplate
                  :keyword="keyword"
                  @search="isOpenAdvanceSearchDialog = true"
                  @simpleSearch="simpleSearch"
                >
                </searchTemplate>
              </template>
            </subHeader>
          </template>

          <template #body>
            <div class="list">
              <!-- header-title -->
              <div class="header-title flex-row flex__between margin-bottom-10">
                <div class="leftSection flex-row flex__left">
                  <div class="theTitle theTitle__lv5">
                    STT
                  </div>
                  <div
                    class="theTitle theTitle__lv1 flex-row flex__left clickable"
                    @click="doSort('quote')"
                  >
                    Trích yếu
                    <sort-caret :order="order" :sort="sort" :field="'quote'"/>
                  </div>
                </div>
                <div class="rightSection flex-row flex__right ">
                  <div
                    class="theTitle theTitle__lv2 flex-row flex__left clickable"
                    @click="doSort('docDate')"
                  >
                    Ngày văn bản
                    <sort-caret
                      :order="order"
                      :sort="sort"
                      :field="'docDate'"
                    />
                  </div>
                </div>
              </div>
              <!-- list-docs -->
              <VuePerfectScrollbar
                class="scroll-area"
                :settings="perfectScrollbarSetting"
                infinite-wrapper
              >
                <div class="list-docs">
                  <div
                    v-for="(item, $itemIndex) in outgoingDocs"
                    v-bind:key="$itemIndex"
                    class="item flex-row flex__between"
                  >
                    <div class="leftSection flex-row flex__left">
                      <div class="theTitle__lv5">
                        <div class="flex-row flex__left">
                          <div class="section-check">
                            <span class="stt flex-row flex__center">{{
                                $itemIndex + 1
                              }}</span>
                          </div>
                          <i
                            class="fas fa-file color__silver"
                            @click.stop="
                              downloadAttachment(
                                item,
                                ATTACHMENT_OBJECT_TYPE.VB_DI
                              )
                            "
                          ></i>
                        </div>
                      </div>
                      <div class="theTitle__lv1 margin-right-10">
                        <div class="title-docs flex-col flex__left">
                          <div class="tt_1 clickable">
                            {{ item.quote }}
                          </div>
                          <div class="tt_2 flex-row flex__left">
                            <span v-if="item.docCode"
                            >#{{ item.docCode }}&nbsp;&nbsp;</span
                            >
                            <el-tag
                              v-if="item.docTypeName"
                              size="mini"
                              :class="['priority', 'lv3']"
                            >{{ item.docTypeName }}
                            </el-tag>

                            <el-tag
                              v-if="isShowPiority(item.priorityId)"
                              size="mini"
                              :class="[
                                'priority',
                                getPiorityClass(item.priorityId)
                              ]"
                            >
                              <i class="fas fa-bolt"></i>
                              <span>
                                {{ item.priorityName }}
                              </span>
                            </el-tag>
                            <span>
                               <el-tooltip
                                 content="Văn bản điện tử"
                                 placement="top"
                                 effect="dark"
                                 v-if="isVbDienTu(item)"
                               >
                                 <div class="eIcon">e</div>
                               </el-tooltip>
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div class="rightSection flex-row flex__right">
                      <div
                        class="theTitle__lv3 flex-row flex__left font-size__small"
                      >
                        <div class="flex-row flex__right">
                          <i class="cellIcon color__silver fas fa-clock"></i>
                          {{
                            item.docDate | dateFormatter({nullValue: "-"})
                          }}
                        </div>
                      </div>
                    </div>

                  </div>

                  <infinite-loading
                    ref="infiniteLoading"
                    spinner="spiral"
                    @infinite="infiniteHandler"
                  >
                    <div slot="no-more"></div>
                    <div slot="no-results">Không có dữ liệu</div>
                  </infinite-loading>
                </div>
              </VuePerfectScrollbar>
            </div>
          </template>
        </listTemplate>
      </div>
      <vb-di-thay-doi-status-dialog
        :isOpen="isOpenDialogCreate"
        @closed="isEnableDialogCreate = false"
        @closeDialog="isOpenDialogCreate = false"
        @success="createDocSuccess"
      />

    </template>
  </listTemplate>
</template>
<script>
import BreakWordSpan from "../../adminstration/ketluan/break-word-span";
import buildShortNameFilter from "../../../filters/buildShortNameFilter";
import outGoingDocSevice from "../../../services/outgoingDocService";
import dateFormatter from "../../../filters/dateFormatter";
import constants from "../../../constants";
import utils from "../../../services/utils";
import {EventBus} from "../../../event-bus.js";
import dateUtils from "../../../dateUtils";
import vbAttachmentTokenMixin from "../../../mixins/vbAttachmentTokenMixin";
import buildAttachmentURL from "../../../filters/buildAttachmentURL";
import handleRequestErrorMixin from "../../handleRequestErrorMixin";
import h from "../../../services/h";
import vbDiThayDoiStatusDialog from "./vb-di-thay-doi-status-dialog";
export default {
  name: "vb-di-thay-doi-status-index",
  components: {
    vbDiThayDoiStatusDialog,
    BreakWordSpan,
    InfiniteLoading: () => import("vue-infinite-loading"),
    listTemplate: () => import("../../common/list.vue"),
    headerTemplate: () => import("../../../components/header/main-header.vue"),
    searchTemplate: () => import("../../common/search.vue"),
    VuePerfectScrollbar: () => import("vue-perfect-scrollbar"),
    subHeader: () => import("../../../components/main/sub-header.vue"),
    displayPeople: () => import("../../common/displayPeople.vue"),
  },

  mixins: [vbAttachmentTokenMixin, handleRequestErrorMixin],
  filters: {dateFormatter, buildShortNameFilter, buildAttachmentURL},

  data() {
    return {
      isOpenMultiScanDocOutDialogCreate: false,
      isEnableMultiScanDocOutDialogCreate: false,

      isOpenChosenFileTypeDialog: false,

      sortList: [],
      isOpenDialogCreate: false,
      isEnableDialogCreate: false,

      ATTACHMENT_OBJECT_TYPE: constants.ATTACHMENT_OBJECT_TYPE,
      dateQuickFilterOption: utils.getDefaultDateQuickFilterOption(),

      isOpenAdvanceSearchDialog: false,
      isEnableAdvanceSearchDialog: false,
      perfectScrollbarSetting: {maxScrollbarLength: 350},

      isOpenBHanhDocOut: false,
      isEnableBHanhDocOut: false,
      docAfterSave: null,

      outgoingDocs: [],

      page: 0,
      size: 10,
      advanceSearchForm: {},
      sort: null,
      order: null,
      keyword: null,
      signerTimeRange: [null, null]
    };
  },

  mounted() {
    EventBus.$on(this.currentRoute, options => {
      this.doSearch();
    });
  },

  computed: {
    currentRoute() {
      return this.$route.path.split("/")[3];
    },
    userDeptRoleId() {
      return this.$route.params.userDeptRoleId;
    },
    dateRange() {
      return this.$route.params.dateRange;
    }
  },

  watch: {
    isOpenBHanhDocOut(newValue) {
      newValue && (this.isEnableBHanhDocOut = newValue);
    },
    isOpenMultiScanDocOutDialogCreate(newValue) {
      newValue && (this.isEnableMultiScanDocOutDialogCreate = newValue);
    },

    isOpenDialogCreate: function (newValue) {
      newValue && (this.isEnableDialogCreate = newValue);
    },
    isOpenAdvanceSearchDialog: function (newValue) {
      newValue && (this.isEnableAdvanceSearchDialog = newValue);
    }
  },

  created() {
    this.initQuery();
  },

  methods: {
    createMultiScanDocSuccess() {
      this.message("Thông báo", "Scan văn bản thành công", "success", 2000)
      this.isOpenMultiScanDocOutDialogCreate = false;
      EventBus.$emit('loadCounting', '');
      this.doSearch();
    },
    isVbDienTu(item) {
      if(item.eFlag&&item.eFlag==='1'){
        return true;
      }else {
        return false;
      }
    },
    inPhieuTrinhKi(item) {
      let baseServiceURL = constants.BASE_SERVICE_URL;
      let reportUrl = constants.IN_PHIEU.VB_DI;
      window.open(
        `${baseServiceURL}${reportUrl}?${utils.serialize({docId: item.id})}`,
      );
    },

    chosenFileType() {
      this.isOpenChosenFileTypeDialog = true
    },

    banHanhVanThuSuccess() {
      this.isOpenBHanhDocOut = false;
      this.doSearch();
    },

    createDocSuccess(event) {
      this.docAfterSave = event.doc;
      this.isOpenDialogCreate = false;
      this.isOpenBHanhDocOut = true;
      this.doSearch();
    },

    initDateRange() {
      this.signerTimeRange =
        (this.dateRange && dateUtils.getDatesByQuickFilter(this.dateRange)) ||
        dateUtils.getDatesByQuickFilter(
          constants.DATE_QUICK_FILTER.CODE.LAST_30_DAYS
        );
      this.fromSignerTime = this.signerTimeRange[0].getTime();
      this.toSignerTime = this.signerTimeRange[1].getTime();
    },

    filterBySignerTimeRange(event) {
      this.advanceSearchForm.fromSignerTime =
        this.signerTimeRange && this.signerTimeRange[0]
          ? this.signerTimeRange[0].getTime()
          : undefined;
      this.advanceSearchForm.toSignerTime =
        this.signerTimeRange && this.signerTimeRange[1]
          ? this.signerTimeRange[1].getTime()
          : undefined;
      this.doSearch();
    },

    initQuery() {
      this.sort = this.$route.query.sort || "updateTime";
      this.order = this.$route.query.order || "desc";
      this.advanceSearchForm = {
        keyword: this.$route.query.keyword || undefined,
        fromSignerTime: this.$route.query.fromSignerTime
          ? parseInt(this.$route.query.fromSignerTime)
          : undefined,
        toSignerTime: this.$route.query.toSignerTime
          ? parseInt(this.$route.query.toSignerTime)
          : undefined,
        docTypeId: this.$route.query.docTypeId
          ? parseInt(this.$route.query.docTypeId)
          : undefined,
        priorityId: this.$route.query.priorityId
          ? parseInt(this.$route.query.priorityId)
          : undefined,
        quote: this.$route.query.quote || undefined,
        otherReceivePlaces: this.$route.query.otherReceivePlaces || undefined,
        receiveDeptId: this.$route.query.receiveDeptId || undefined,
        fileContent: this.$route.query.fileContent || undefined
      };
      this.keyword = this.advanceSearchForm.keyword;
    },

    buildQuery() {
      return utils.merge(
        {sort: this.sort || "updateTime", order: this.order || "desc"},
        this.advanceSearchForm
      );
    },


    simpleSearch(keyword) {
      this.keyword = this.advanceSearchForm.keyword = keyword;
      this.advanceSearchForm.docTypeId = undefined;
      this.advanceSearchForm.priorityId = undefined;
      this.advanceSearchForm.quote = undefined;
      this.advanceSearchForm.otherReceivePlaces = undefined;
      this.advanceSearchForm.receiveDeptId = undefined;
      this.advanceSearchForm.fileContent = undefined;
      this.doSearch();
    },

    doSort(sort) {
      let order =
        sort == this.sort ? (this.order == "asc" ? "desc" : "asc") : "asc";
      this.sort = sort;
      this.order = order;
      this.doSearch();
    },

    doSearch() {
      this.$router.replace({
        name: this.$router.name,
        params: this.$route.params,
        query: this.buildQuery()
      });

      this.outgoingDocs = [];
      this.page = 0;
      this.$nextTick(() => this.$refs.infiniteLoading.stateChanger.reset());
    },

    infiniteHandler($state) {
      this.list().then(items => {
        this.page += 1;
        items && items.length ? $state.loaded() : $state.complete();
      });
    },

    list() {
      let pageable
      if (this.sortList && this.sortList.length > 0) {

        let sort = [];
        h.each(this.sortList, (item) => {
          sort.push(item);
        })
        pageable = {
          page: this.page,
          size: this.size,
          sort: sort
        };
      } else {
        pageable = {
          page: this.page,
          size: this.size,
          sort: [this.sort, this.order].join(",")
        };
      }

      return outGoingDocSevice
        .findAllVbDiThayDoiTrangThai(pageable)
        .then(response => {
          let items = response.data;
          items && this.outgoingDocs.push(...items);
          return items;
        });
    },


    getPiorityClass(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1
        ? "lv1"
        : "lv4";
    },

    isShowPiority(id) {
      return constants.HIGH_LEVELS_PIORITY_IDS.indexOf(id) != -1;
    },
  }
};
</script>
<style scoped>
#searchBox {
  position: relative;
  width: 100%;
}

.advance-search {
  font-size: 17px;
  color: #005eb1;
  position: absolute;
  right: 5%;
  top: 50%;
  transform: translateY(-50%);
}

.icon-very__small {
  height: 14px;
  padding-top: 4px;
}

.icon-info {
  background-color: #f0c330;
  border-radius: 50%;
  width: 15px;
  height: 15px;
  margin-top: -1px;
  margin-left: 2px;
}
.eIcon{
  border: solid 1px #007aff;
  border-radius: 2px;
  padding: 0px 3px;
  font-size: 11px;
  color: goldenrod;
  margin-left:2px;
}
</style>



// WEBPACK FOOTER //
// src/views/setting/quanLyThayDoiStatusVbDi/vb-di-thay-doi-status-index.vue